import React from "react";
import "../App/App.css";
import "../Footer/Footer.css";

function Footer() {
  return (
    <footer>
      <h3 className="footer-name">CosmoChimica</h3>
      <p className="footer-p">Musical Theatre Company</p>
      <p className="footer-p"> South Slope 11215 New York</p>
      <p className="footer-p">contact@cosmochimica.com</p>
      <p className="footer-p">Phone 718-531-2898</p>
    </footer>
  );
}
export default Footer;
